const webview_states = {
    $WebviewForm : []    
}

export default webview_states